import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import { OPERATION_STATUS } from '../models/user-identification';

export interface IDynamicFormSubmitPayload {
	responses: Array<{
		step_uuid: string;
		fields: Array<{
			uuid: string;
			value: string | boolean | null;
		}>;
	}>;
	complete?: boolean;
}

export interface IDynamicFormSubmitResponse {
	uuid: string;
	current_step_order?: number;
	filledFormFields?: Array<{ uuid: string; value: string }>;
	/** Estado de la operación FORM tras cotejo match_data (NIF-553). */
	state?: OPERATION_STATUS;
}

@Injectable({
	providedIn: 'root',
})
export class DynamicFormService extends ApiService {
	public submit(
		operationUuid: string,
		payload: IDynamicFormSubmitPayload,
	): Observable<{ data: IDynamicFormSubmitResponse }> {
		return this.http.post<{ data: IDynamicFormSubmitResponse }>(
			`${environment.identity2}/filled-forms/${operationUuid}`,
			payload,
			{ headers: this.getHeaders() },
		);
	}
}
